import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';

import Sidebar from './Sidebar';
import TopBar from './TopBar';
import DevUserSwitcher from './DevUserSwitcher';
import '../../styles/design-tokens.css';

const ROUTE_TITLES = [
  ['/orders/parts',                'Part Orders — Logistics Hub'],
  ['/orders/part-replenishment',   'Part Replenishment — Logistics Hub'],
  ['/shipments/dispatch',          'Dispatch Board — Logistics Hub'],
  ['/shipments/replenishment-shipments',  'Replenishment — Logistics Hub'],
  ['/inventory/search',            'Inventory — Logistics Hub'],
  ['/inventory/reverse-logistics', 'Reverse Logistics — Logistics Hub'],
  ['/accounting/purchase-orders/', 'Purchase Orders — Logistics Hub'],
  ['/accounting/payments/',         'Payment Detail — Logistics Hub'],
  ['/accounting/payments',          'Payments — Logistics Hub'],
  ['/accounting/reports',           'Reports — Logistics Hub'],
  ['/inventory/stock-locations/',  'Stock Location Detail — Logistics Hub'],
  ['/inventory/stock-locations',   'Stock Locations — Logistics Hub'],
  ['/inventory/suppliers/',        'Supplier Detail — Logistics Hub'],
  ['/inventory/suppliers',         'Suppliers — Logistics Hub'],
  ['/settings/users',              'Users — Logistics Hub'],
  ['/settings/notifications',      'Notifications — Logistics Hub'],
  ['/settings/integrations',       'Integrations — Logistics Hub'],
  ['/settings/customer-access',    'Customer Access — Logistics Hub'],
  ['/',                            'Dashboard — Logistics Hub'],
];

const SIDEBAR_WIDTH = 260;
const SIDEBAR_COLLAPSED = 72;

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const match = ROUTE_TITLES.find(([prefix]) => location.pathname.startsWith(prefix));
    document.title = match ? match[1] : 'Logistics Hub';
  }, [location.pathname]);

  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#ffffff' }}>
      <Sidebar collapsed={collapsed} />

      {/* Main area — shifts right based on sidebar width */}
      <Box
        component="main"
        sx={{ flex: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: `${sidebarWidth}px`,
          minHeight: '100vh',
          backgroundColor: 'transparent',
          transition: 'margin-left 0.2s ease',
        }}
      >
        <TopBar collapsed={collapsed} onToggle={() => setCollapsed((prev) => !prev)} />

        {/* Page content — rounded top corners, sits below fixed TopBar */}
        <Box
          sx={{ flex: 1,
            mt: '88px',               /* offset for fixed TopBar */
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            backgroundColor: 'var(--background)',
            overflowY: 'auto',
            overflowX: 'hidden',
            pt: 3,
            px: 0,
            pb: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      <DevUserSwitcher />
    </Box>
  );
}
